<template>
  <router-view />
</template>

<script setup lang="ts">
  import { onMounted, watch } from "vue";
  import { useRouter } from "vue-router";
  import { useUIStore } from "@/store/modules/ui";
  import { useUserStore } from "@/store/modules/user";
  import { useGlobalTheme } from "@/composables/useTheme";
  import { setupSocketAutoManagement } from "@/composables/useSocketIO";

  const uiStore = useUIStore();
  const userStore = useUserStore();
  const router = useRouter();

  watch(
    [() => userStore.isLogin, () => userStore.LoginIsValid],
    ([isLogin, LoginIsValid]) => {
      if (isLogin && !LoginIsValid) {
        uiStore.showBindEmailPhoneDialog("phone", false);
      }
    },
    { immediate: true }
  );

  // 初始化全局主题实例，确保暗黑模式默认生效
  useGlobalTheme();

  // 启动Socket连接自动管理
  setupSocketAutoManagement();

  onMounted(() => {
    // 初始化时从 localStorage 恢复 token
    const token = localStorage.getItem("token");
    if (token) {
      userStore.setToken(token);
    }
  });

  // 监听登录状态变化，处理跨标签页退出登录后的页面跳转
  watch(
    () => userStore.isLogin,
    (isLogin, wasLogin) => {
      // 只有当从登录状态变为未登录状态时才处理跳转
      if (wasLogin && !isLogin) {
        const currentRoute = router.currentRoute.value;
        const requiresAuth = currentRoute.meta.requiresAuth;

        // 如果当前路由需要认证，且不是已经在dashboard页面，则跳转到dashboard
        if (requiresAuth === true && currentRoute.path !== "/login" && currentRoute.path !== "/app/dashboard") {
          router.push("/app/dashboard");
        } else {
          console.log("[App] 无需跳转，当前路由不需要认证或已在dashboard页面");
        }
      }
    },
    { immediate: false } // 不需要立即执行，只监听变化
  );

  watch(
    () => userStore.userInfo?.last_active_team_id,
    (newTeamId) => {
      console.log("newTeamId>>>>>>>>>>>", newTeamId);
      if (newTeamId) {
        router.replace({ path: "/app/dashboard" });
      }
    }
  );
</script>
